if(!customElements.get('shop-the-post')) {

  class ComponentShopThePost extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.slidesWrapper = this.querySelector('.keen-slider');
      this.dots = this.querySelector('.keen-dots');
      this.prevButton = this.querySelector('.keen-arrow.prev');
      this.nextButton = this.querySelector('.keen-arrow.next');
      this.slides = this.slidesWrapper.children;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;
      this.autoplay = this.dataset.autoplay;
      this.pauseOnHover = this.dataset.pauseOnHover!=='false';
      this.spacing = this.dataset.spacing;
      this.carousel = false;

      setTimeout(()=>{ //The timeout is for the customizer
        this.initCarousel();
      }, 1);

      this.bindCustomizerEvents();
    }

    initCarousel() {
      if(this.slides.length > 1) {
        this.carousel = new KeenSlider(this.slidesWrapper, {  
          wheel: false,
          dots: this.dots,
          prevButton: this.prevButton,
          nextButton: this.nextButton,
          setContainerHeight: this.effect=='fade',
          autoplay: this.autoplay,
          pauseOnHover: this.pauseOnHover,
          spacing: this.spacing,
          customAnimation: false,
          setContainerHeight: false,
          mode: "snap",
          loop: false,
          breakpoints: {
            '(min-width: 67px)': {
              slidesPerView: this.slidesPerViewDesktop
            },
            '(min-width: 39px) and (max-width: 66em)': {
              slidesPerView: this.slidesPerViewTablet
            },
            '(max-width: 38em)': {
              slidesPerView: this.slidesPerViewMobile
            }
          }
        });
      } else {
        this.slidesWrapper.classList.add('initialized');
      }
    }

    bindCustomizerEvents() {
      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e)=>{
          let index = Array.from(this.slides).findIndex(x=>x==e.target);
          if(index>=0) {
            setTimeout(()=>{
              this.carousel.moveToSlideRelative(index, true, 0)
            }, 10);
          }
        });
      }
    }

  }

  customElements.define('shop-the-post', ComponentShopThePost);
}